module.exports = __webpack_public_path__ + "static/client_5_after-f9441189d626f39e8136e50497882269.jpg";